import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentLine  {
    _originalTypeClassName = "zERP.BO.PaymentLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentLine.translate = translateService;
}
this.Id = null;
this.PaymentAmount = null;
this.Status = null;
this.PaymentReference = null;
this.InboundCheckNumber = null;
this.ByExistingMoneyTransaction = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
PaymentAmount:any;
Status:any;
PaymentReference:any;
InboundCheckNumber:any;
ByExistingMoneyTransaction:any;
PaymentOrderPayment:any;
BankAccountFrom:any;
CashAccount:any;
PaymentMethod:any;
BankAccountTo:any;
Check:any;
Checkbook:any;
MoneyTransaction:any;
CancelMoneyTransaction:any;
Cashier:any;
CheckNumber:any;
static setPaymentOrderPayment = ($this, value) => {
var oldValue = $this.PaymentOrderPayment;
$this.PaymentOrderPayment = value;
if (value != null) {
if (oldValue != null) {
Domain.Payment.removeLines(oldValue, $this);
}
Domain.Payment.addLines(value, $this);
}
}
static setBankAccountFrom = ($this, value) => {
var oldValue = $this.BankAccountFrom;
$this.BankAccountFrom = value;
if (value != null) {
if (oldValue != null) {
Domain.BankAccount.removePaymentOrderPaymentLine(oldValue, $this);
}
Domain.BankAccount.addPaymentOrderPaymentLine(value, $this);
}
}
static setCashAccount = ($this, value) => {
var oldValue = $this.CashAccount;
$this.CashAccount = value;
if (value != null) {
}
}
static setPaymentMethod = ($this, value) => {
var oldValue = $this.PaymentMethod;
$this.PaymentMethod = value;
if (value != null) {
}
}
static setBankAccountTo = ($this, value) => {
var oldValue = $this.BankAccountTo;
$this.BankAccountTo = value;
if (value != null) {
}
}
static setCheck = ($this, value) => {
var oldValue = $this.Check;
$this.Check = value;
if (value != null) {
if (oldValue != null && oldValue.Payment != null) { oldValue.Payment = null; }
if ($this.Check.Payment !== $this) {
Domain.Check.setPayment(value, $this);
}
}
}
static setCheckbook = ($this, value) => {
var oldValue = $this.Checkbook;
$this.Checkbook = value;
if (value != null) {
}
}
static setMoneyTransaction = ($this, value) => {
var oldValue = $this.MoneyTransaction;
$this.MoneyTransaction = value;
if (value != null) {
}
}
static setCancelMoneyTransaction = ($this, value) => {
var oldValue = $this.CancelMoneyTransaction;
$this.CancelMoneyTransaction = value;
if (value != null) {
}
}
static setCashier = ($this, value) => {
var oldValue = $this.Cashier;
$this.Cashier = value;
if (value != null) {
}
}
static setCheckNumber = ($this, value) => {
var oldValue = $this.CheckNumber;
$this.CheckNumber = value;
if (value != null) {
}
}

static AutoFillAmount($this: any, payment: any,totalAmount: any): any{let alreadyPaidAmount = payment?.Lines?.linq?.where((l) => l != $this)?.toArray()?.linq?.sum((l) => l?.PaymentAmount);
let remainingAmount = Joove.Common.safeNumber(totalAmount) - Joove.Common.safeNumber(alreadyPaidAmount);
if (CLMS.Framework.Number.LessThan(() => remainingAmount, () => 0)) {remainingAmount = 0;}
$this.PaymentAmount = remainingAmount;
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static HasCheck($this: any): any{return $this?.PaymentMethod != null && Domain.PaymentMethodDetailTypeValueObject.IsCheck($this?.PaymentMethod) && $this?.Check != null && !(Domain.Check.IsNew($this?.Check));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}